import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';
import * as _ from 'lodash';
import groupList from '../../../Management/group/group.List.i18n'

//restful api
import { userWmds as wmds } from '@/service/api/wmds';

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Registed_at', sortable: true, thStyle: 'width: 12%' },
    { key: 'group', label: 'Group', sortable: true, thStyle: 'width: 12%' },
    { key: 'is_alive', label: 'Status', sortable: true, thStyle: 'width: 12%' },
    { key: 'level', label: 'Level', sortable: true, thStyle: 'width: 12%' },
    { key: 'type', label: 'Type', sortable: true, thStyle: 'width: 12%' },
    { key: 'code', label: 'Code', sortable: true },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '등록일', sortable: true, thStyle: 'width: 12%' },
    { key: 'group', label: '그룹', sortable: true, thStyle: 'width: 12%' },
    { key: 'is_alive', label: '상태', sortable: true, thStyle: 'width: 12%' },
    { key: 'level', label: '위험도', sortable: true, thStyle: 'width: 12%' },
    { key: 'type', label: '타입', sortable: true, thStyle: 'width: 12%' },
    { key: 'code', label: '코드', sortable: true },
  ]
}


export default {
  components: { DatePicker, cSwitch, vSelect, groupList },
  name : "userPattern",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => ({
    group_name : '',
    chainGroup : false,
    custom,
    codes,
    so : default_opt(),
    model : { total : 0, enable_S : 0, disable : 0, enable_D : 0, S : 0, U : 0, R : 0, M : 0 },
    sync : { interval : 15, stop : false, th : undefined },
    hide_del : true,
    nbsp : "\u00A0"
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_del'] = '';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(['group_id'].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      } else if(k == 'type') {
        return { name : k, value : `${(v.substring(0, 1) || '').toUpperCase()}`, op : '=' }
      } else if(k == 'level') {
        if(v == 'danger') { return { name : k, value : 'H', op : '=' } }
        else if(v == 'caution') { return { name : k, value : 'N', op : '=' } }
        else { return { name : k, value : `${(v.substring(0, 1) || '').toUpperCase()}`, op : '=' } }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let and = []
      let so = {
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : and
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      // if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if( this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
      if(this.partner) { so.body.and.push({ name : "partner_id", Value : this.partner.id, op : "=" }) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return wmds.listUser(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      let and = [];
      wmds.summaryUser({ and : and, or : [], sort : [] })
        .then(rs => { this.model = Object.assign(this.model, { enable_S : rs.body.enable, enable_D : ((rs.body.total - rs.body.disable) - rs.body.enable) , disable : rs.body.disable, total : rs.body.total, S : rs.body.S,
        R : rs.body.R, M : rs.body.M, U : rs.body.U }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      if(this.view_detail == false) { this.$emit("select", item); }
      else {
        this.$router.push({ name : 'wmds_upattern', params : { id : item.id } });
      }
    },
    add: async function() {
      try {
        let check_id = '';
        check_id = this.model.id ? `${await wmds.updateUser(this.model)}` : `${await wmds.insertUser(this.model)}`;

        let rs = check_id;
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name); this.list();
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  watch: { '$route' (to, from) { this.$on('refresh', this.refresh()) } },
  created() { console.log('wmds.user.pattern.list.vue', 'created'); this.$root.$on('select', this.setGroup); },
  destroyed() { console.log('wmds.user.pattern.list.vue', 'destroyed'); },
  mounted() { console.log('wmds.user.pattern.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}